// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingsDetails__Jge78 {
  padding: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: calc(100% - 55px);
  background: var(--tables-main-surface);
}
.costSavingsDetails__Jge78::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.costSavingsDetails__Jge78::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.costSavingsDetails__Jge78::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.costSavingsDetails__Jge78::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 860px) {
  .costSavingsDetails__Jge78 {
    padding: 15px;
    row-gap: 15px;
  }
}

.costSavingsInfoBlock__RlVBP {
  display: flex;
  flex-wrap: wrap;
}

.filtersBlock__HgEWx {
  display: flex;
  align-items: center;
  column-gap: 15px;
  border: 1px solid var(--header-stroke);
  background: var(--tables-primary-row-surface-default);
  padding: 15px 25px;
}

.skeletonTab__dVkue {
  width: 247px;
  height: 35px;
}

.uploadIcon__h7ab6 {
  cursor: pointer;
}
.uploadIcon__h7ab6 path {
  fill: var(--buttons-surface);
}
.uploadIcon__h7ab6:focus {
  outline: none;
}

div.downloadMetricsTooltip__ftKPB {
  z-index: 40;
}`, "",{"version":3,"sources":["webpack://./../src/pages/CostSavingsDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,sCAAA;AAzEF;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA2DE;EATF;IAUI,aAAA;IACA,aAAA;EAxDF;AACF;;AA2DA;EACE,aAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qDAAA;EACA,kBAAA;AAxDF;;AA2DA;EACE,YAAA;EACA,YAAA;AAxDF;;AA2DA;EACE,eAAA;AAxDF;AA0DE;EACE,4BAAA;AAxDJ;AA2DE;EACE,aAAA;AAzDJ;;AA6DA;EACE,WAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingsDetails {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: calc(100% - 55px);\n  background: var(--tables-main-surface);\n  @include scrollBar;\n\n  @media (max-width: 860px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.costSavingsInfoBlock {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.filtersBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n  border: 1px solid var(--header-stroke);\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px 25px;\n}\n\n.skeletonTab {\n  width: 247px;\n  height: 35px;\n}\n\n.uploadIcon {\n  cursor: pointer;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\ndiv.downloadMetricsTooltip {\n  z-index: 40;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingsDetails": `costSavingsDetails__Jge78`,
	"costSavingsInfoBlock": `costSavingsInfoBlock__RlVBP`,
	"filtersBlock": `filtersBlock__HgEWx`,
	"skeletonTab": `skeletonTab__dVkue`,
	"uploadIcon": `uploadIcon__h7ab6`,
	"downloadMetricsTooltip": `downloadMetricsTooltip__ftKPB`
};
module.exports = ___CSS_LOADER_EXPORT___;
